var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_330_248)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.69 2.82C14.2817 2.0098 15.0425 1.33795 15.9197 0.851013C16.7969 0.364076 17.7694 0.0736971 18.77 0C18.8554 0.929882 18.7515 1.86743 18.4644 2.75602C18.1774 3.6446 17.7132 4.4658 17.1 5.17C16.556 5.92713 15.8279 6.53296 14.9844 6.93018C14.141 7.3274 13.2102 7.50288 12.28 7.44C12.1821 6.61425 12.2568 5.77716 12.4995 4.98184C12.7423 4.18652 13.1477 3.45034 13.69 2.82ZM12.75 9.16C13.75 9.16 15.75 7.78 18.23 7.78C19.403 7.72648 20.5702 7.97407 21.6204 8.49919C22.6707 9.02431 23.569 9.8095 24.23 10.78C23.224 11.3335 22.3851 12.1471 21.8011 13.1358C21.217 14.1244 20.9093 15.2517 20.91 16.4C20.9384 17.6952 21.3456 18.9537 22.0814 20.02C22.8171 21.0864 23.8492 21.9138 25.05 22.4C25.05 22.4 22.15 30.27 18.24 30.27C16.44 30.27 15.05 29.1 13.16 29.1C11.27 29.1 9.31 30.32 8.07 30.32C4.51 30.33 0 22.86 0 16.86C0 10.86 3.82 7.86 7.4 7.86C9.73 7.86 11.54 9.16 12.75 9.16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_330_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.07,
    height: 30.33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleWhite);
export default __webpack_public_path__ + "static/media/apple_white.1d467903f9ef534ed1a1e9a5a72f13d7.svg";
export { ForwardRef as ReactComponent };